import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ShardStormAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 30; i++) {
    const a = (i * 137.5) * Math.PI / 180;
    const d = e.maxRadius + progress * 300;
    const r = getRadiusAtAngle(a, e, d);
    const px = e.pos.x + Math.cos(a) * r;
    const py = e.pos.y + Math.sin(a) * r;
    ctx.beginPath(); ctx.arc(px, py, 3 * (1-progress), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('SHARD_STORM', ShardStormAnimation);
